export const ADMIN_API_ORIGIN = process.env.REACT_APP_API_ORIGIN as string;
export const LABEL_ORIGIN = process.env.REACT_APP_LABEL_ORIGIN as string;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN as string;

/**
 * 当前数据隐私协议的版本号，每当协议更新一次，版本号都要加一
 */
export const agreementVersion = 1;
